import { AllCategoryPage } from './AllCategoryPage'
import { withAllCategoryPage } from './withAllCategoryPage'

const ConnectedAllCategoryPage = withAllCategoryPage(AllCategoryPage)

export { ConnectedAllCategoryPage as AllCategoryPage }
